import {Chip, ChipProps, mergeSlotProps} from '@mui/material';
import {type FC} from 'react';
import {useSuperResLayer} from '@src/hooks/useSuperResLayer.tsx';
import {Layer} from '@src/types/configurations';

export const MAGIC_CSS_GRADIENT = 'linear-gradient(to right, #A6FFB3, #33B1C1)';

export const MagicChip: FC<ChipProps> = ({label, ...props}) => {
  return (
    <Chip
      {...mergeSlotProps(
        {
          sx: {
            fontSize: 10,
            height: 20,
            fontWeight: 500,
            background: MAGIC_CSS_GRADIENT,
            '*': {
              color: 'primary.contrastText',
            },
            '& .MuiChip-deleteIcon': {
              opacity: 0.26,
              '&:hover': {
                opacity: 1,
              },
            },
          },
        },
        props ?? {},
      )}
      label={label}
    />
  );
};

export const SuperResChip: FC<{layer: Layer}> = ({layer}) => {
  const {layer: superResLayer} = useSuperResLayer();
  const showSuperResChip = superResLayer?.id === layer?.id;

  if (!showSuperResChip) {
    return null;
  }

  return (
    <MagicChip
      clickable={false}
      sx={{
        height: 20,
        marginInlineStart: 'auto',
        cursor: 'default',
      }}
      label="SuperRes available"
      data-chameleon="super-res-available"
    />
  );
};

export default SuperResChip;
